import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import win from '../../../shared/win';

export const FormContext = createContext();

const FormContextProvider = ({ children, additionalValues }) => {
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const value = {
    ...win,
    inBuilder: false,
    inCustomise: false,
    inForm: false,
    ...additionalValues,
    hiddenFields: {},
    currentPageNo,
    setCurrentPageNo,
  };

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

FormContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  additionalValues: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FormContextProvider;
